import { render } from "./NavSidebarItem.vue?vue&type=template&id=e654641c&scoped=true"
import script from "./NavSidebarItem.vue?vue&type=script&lang=js"
export * from "./NavSidebarItem.vue?vue&type=script&lang=js"

import "./NavSidebarItem.vue?vue&type=style&index=0&id=e654641c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e654641c"

export default script